import * as STD                                 from '@emersya/mpa-std-lib';
import * as BasketNS                            from '@emersya/mpa-basket-lib';
import CM                                       from '@emersya/mpa-components-manager-lib';
import { Text }                                 from '@emersya/mpa-components-lib';
import ViewerComponent                          from '../../../Viewer/Viewer';

// import { NS as Image }          from '@libs/MPAComponents/Image/Image';

export interface IPlannerFurnitureTileComponentConfiguration extends CM.DOMComponent.IConfiguration {
	readonly productConfiguration : MPAEngineApplication.Configuration['productsComponents'][0];
};

export class PlannerFurnitureTileComponent extends CM.DOMComponent<
	HTMLDivElement,
	PlannerFurnitureTileComponent,
	IPlannerFurnitureTileComponentConfiguration
>
{
	static override initialize() {
		super.initialize();
	};

	readonly plannerProduct! : ViewerComponent.Product;

	get category() {
		return <PlannerFurnitureCategoryTileNS.Component> this.component_parent?.component_parent;
	};

	component_DOM : HTMLDivElement;

	private async onMouseDown(ev : MouseEvent) {
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		if (this.component_DOM.classList.contains('limitReached')) {
			ev.preventDefault();
			return;
		}
		await app.viewer.planner.dragStart(ev, this.plannerProduct);
	};

	override async component_initialize() {
		const PC = this.component_configuration.productConfiguration;
		if (!PC.viewerComponentSKU || !PC.viewerProjectCode) {
			this.component_throwUserError('');
		}
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const extension : Partial<ViewerComponent.IProductExtension> = {
			quantity : null,
			...(app.viewer.productsExtensionById[ PC.SKU ] || {})
		};
		app.viewer.productsExtensionById[ PC.SKU ] = <ViewerComponent.IProductExtension> extension;
		const addToExtension = (data : Partial<ViewerComponent.IProductExtension>) => {
			Object.assign(extension, data);
		};
		if (PC.pricing) {
			// const priceComponent = <Text.Component> this.component_find('@:bottom.left.price');
			// const price = PC.price[ app.currentCurrency.id ];
			// if (!price) {
			// 	this.component_throwUserError('Missing furniture price for current currency!');
			// }
			// const minimalPrice = typeof price === 'number' ? price : STD.misc.getDataInFunctionOfMinimalPositiveValue(price).value;
			// priceComponent.update(minimalPrice.toString() + app.currentCurrency.symbol);
			if (!app.viewer.planner) {
				this.component_throwUserError('');
			}
			addToExtension({
				pricing : BasketNS.Pricing.deserialize(<BasketNS.Pricing.FinalPricing.ISerialized & BasketNS.Pricing.BoundPricing.ISerialized> PC.pricing)
			});
			if (!extension.pricing) {
				this.component_throwUserError('');
			}
			const price = (extension.pricing instanceof BasketNS.Pricing.BoundPricing) ?
				// One day this code will boom 100% sure!
				BasketNS.Pricing.BoundPricing.resolve(extension.pricing, <any>null) :
				extension.pricing.resolve()
			;
			if (!price.exclTax) {
				this.component_throwLibraryError('');
			}
			const priceComponent = <Text.Component> this.component_find('@:bottom.left.price');
			priceComponent.update(price.exclTax.toString() + app.currentCurrency.symbol);
		}

		const PO = app.component_configuration.productsOptions.filter(x => x.component === PC.SKU);
		if (PO.length) {
			const presets : ViewerComponent.IProductPreset[] = [];
			for (const option of PO) {
				if (!option.translations[ '@name' ]) {
					this.component_throwUserError('Option without name!', { option });
				}
				// if (!option.viewerGroups.length) {
				// 	this.component_throwUserError('Option without any viewer groups configuration!', { option });
				// }
				if (option.viewerGroups.length === 0) {
					continue;
				}
				const group : any = option.viewerGroups[ 0 ];
				// const price = option.pricingInfo ? option.price[ app.currentCurrency.id ] : null;
				// if (price === undefined) { // Can be a price or null but not undefined.
				// 	this.component_throwUserError('Option with invalid price!', { option });
				// }
				const groupName : string = group.groupName;
				const configurationName : string = group.configurationName;
				const configuration : Record<string, string> = {};
				configuration[ groupName ] = configurationName;
				presets.push({
					id :          option.SKU,
					name :        option.translations[ '@name' ],
					iconURL :     option.iconURL,
					groups :      configuration,
					pricingInfo : !option.pricingInfo ? null : {
						pricing :                 BasketNS.Pricing.deserialize(<BasketNS.Pricing.FinalPricing.ISerialized & BasketNS.Pricing.BoundPricing.ISerialized> option.pricingInfo.pricing),
						volumeComputationMethod : option.pricingInfo.volumeComputationMethod
					}
				});
			}
			const defaultInFunctionOfGlobalProduct = Object.entries(app.component_configuration.productsOptionsDefaults).
			reduce<Record<string, string>>((a, [ globalProduct, defaults ]) => {
				const defaultPreset = defaults[ PC.SKU ];
				if (defaultPreset) {
					a[ globalProduct ] = defaultPreset;
				}
				return a;
			}, {});
			const self = this;
			addToExtension({
				presets,
				defaultPreset : defaultInFunctionOfGlobalProduct,
				resolveSpecificKey(
					this : ViewerComponent.ProductInstance | ViewerComponent.Product,
					what : 'pricing' | 'quantity' | 'customImagesPricing' | 'defaultPreset'
				)
				{
					if (what === 'defaultPreset') {
						if (!app.currentProductSKU) {
							<never> self.component_throwLibraryError('Not implemented!');
						}
						return (app.currentProductSKU);
					}
					<never> self.component_throwLibraryError('Not implemented!');
					return '';
				}
			});
		}
		const nameTr = PC.translations[ '@name' ];
		if (!nameTr) {
			this.component_throwUserError(`Product component<${ PC.SKU }> does not have @name translation!`);
		}
		(<any> this).plannerProduct = this.category.plannerCategory.createProduct({
			SKU :            PC.SKU,
			previewPath :    PC.iconURL || '',
			name :           nameTr[ app.currentLanguage ],
			positionsSetId : null,
			nodes :          [
				{
					SKU :           PC.viewerComponentSKU,
					projectCode :   PC.viewerProjectCode,
					localId :       'global',
					parentLocalId : 'root',
					snappable :     false,
					matrix :        app.viewer.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0),
					tracked :       true,
					draggable :     true
				}
			]
		});
		await super.component_initialize();
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IPlannerFurnitureTileComponentConfiguration
	)
	{
		STD.object.deepMergeAssign(configuration, [
			{
				'@innerConfigurations' : {
					name :   {
						'@translations' : {
							text : configuration.productConfiguration.translations[ '@name' ]
						}
					},
					bottom : {
						'@innerConfigurations' : {
							right : {
								'@innerConfigurations' : {
									thumbnail : {
										URL : configuration.productConfiguration.iconURL
									}
								}

							}
						}
					}
				}
			}
		]);
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag :    'div',
			events : {
				mousedown : this.onMouseDown.bind(this)
			},
		});
	};
};
export namespace NS {
	export const Component = PlannerFurnitureTileComponent;
	export type Component = PlannerFurnitureTileComponent;
	export type Configuration = IPlannerFurnitureTileComponentConfiguration;
}
import manifestXMLSource                        from './PlannerFurnitureProductTile.xml';
import './PlannerFurnitureProductTile.scss';
import { NS as MPAEngineApplication }           from '../../../../mpa-engine/Application/MPAEngineApplication';
import { NS as PlannerFurnitureCategoryTileNS } from '../CategoryTile/PlannerFurnitureCategoryTile';


CM.declare({
	id :       'viewer-planner-furniture-productTile',
	type :     PlannerFurnitureTileComponent,
	manifest : manifestXMLSource
});
